<template>
  <div class="px-5 pb-5">
    <div class="border-input">
      <div v-for="(item, index) in filterData" :key="index">
        <div class="grid gap-4 md:grid-cols-2">
          <div class="col-span-2 w-full">
            <label
                class="flex items-center justify-between pb-1 font-primary font-normal text-gray-400"
            >
              {{ __('Current location') }}
              <div v-if="markMandatory">
                <Toggle
                    v-model="item.location[0].mandatory"
                    :value="item.location[0].mandatory"
                    :setid="'mandatory'"
                />
              </div>
            </label>

            <div class="relative">
              <Multiselect
                  v-model="item.location[0].value"
                  :values="locations"
                  @clear="() => { item.location[0].value = null; locations = []; }"
                  :clearable="true"
                  type="dynamic"
                  @query="(query) => getLocationsByQuery(query)"
              />
            </div>
          </div>

          <div class="col-span-2 w-full">
            <label
                class="flex items-center justify-between pb-1 font-primary font-normal text-gray-400"
            >
              {{ __('Career status') }}
              <div v-if="markMandatory">
                <Toggle
                    v-model="item.career_status[0].mandatory"
                    :value="item.career_status[0].mandatory"
                    :setid="'mandatory'"
                />
              </div>
            </label>
            <div class="relative">
              <Multiselect
                  v-model="item.career_status[0].value"
                  :values="item.career_status[0].values"
                  @clear="item.career_status[0].value = null"
                  :clearable="true"
                  type="static"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import { Toggle, Multiselect } from '../../global';
import { __ } from '../../../helpers';
import axios from "axios";

const props = defineProps({
  markMandatory: Boolean,
  filterData: Array
});

const locations = ref([]);

const getValues = (array) => {
  return array.map((item) => ({ name: item.name, id: item.id }));
};

const getLocationsByQuery = async (query) => {
  if (!query || query.length < 3) return;

  try {
    const { data } = await axios.get(route('cities.find_cities'), {
      params: { q: query }
    });
    locations.value = getValues(data);
  } catch (error) {
    console.error('Error fetching locations:', error);
  }
};
</script>
